<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    :fill="iconColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5013 5.00245H13.3346V3.61078C13.3151 3.0773 13.0848 2.57333 12.6943 2.20936C12.3038 1.84539 11.7848 1.65111 11.2513 1.66912H8.7513C8.21776 1.65111 7.69885 1.84539 7.30833 2.20936C6.9178 2.57333 6.68752 3.0773 6.66797 3.61078V5.00245H2.5013C2.28029 5.00245 2.06833 5.09025 1.91205 5.24653C1.75577 5.40281 1.66797 5.61477 1.66797 5.83578C1.66797 6.0568 1.75577 6.26876 1.91205 6.42504C2.06833 6.58132 2.28029 6.66912 2.5013 6.66912H3.33464V15.8358C3.33464 16.4988 3.59803 17.1347 4.06687 17.6036C4.53571 18.0724 5.17159 18.3358 5.83464 18.3358H14.168C14.831 18.3358 15.4669 18.0724 15.9357 17.6036C16.4046 17.1347 16.668 16.4988 16.668 15.8358V6.66912H17.5013C17.7223 6.66912 17.9343 6.58132 18.0906 6.42504C18.2468 6.26876 18.3346 6.0568 18.3346 5.83578C18.3346 5.61477 18.2468 5.40281 18.0906 5.24653C17.9343 5.09025 17.7223 5.00245 17.5013 5.00245ZM8.33464 3.61078C8.33464 3.47745 8.50964 3.33578 8.7513 3.33578H11.2513C11.493 3.33578 11.668 3.47745 11.668 3.61078V5.00245H8.33464V3.61078ZM15.0013 15.8358C15.0013 16.0568 14.9135 16.2688 14.7572 16.425C14.6009 16.5813 14.389 16.6691 14.168 16.6691H5.83464C5.61362 16.6691 5.40166 16.5813 5.24538 16.425C5.0891 16.2688 5.0013 16.0568 5.0013 15.8358V6.66912H15.0013V15.8358Z"
    />
  </svg>
</template>

<script setup>
defineProps({
  width: {
    type: [Number, String],
    required: false,
    default: 24
  },
  height: {
    type: [Number, String],
    required: false,
    default: 24
  },
  iconColor: {
    type: String,
    required: false,
    default: '#232323'
  }
})
</script>
